import {
  useState,
  useContext,
  useCallback,
} from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useAudience = () => {
  const {
    api,
    userID,
    audienceGroups,
    setAudienceGroups,
    setAudienceFetched,
  } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);

  const postRequest = useCallback(
    async (endpoint, body) => {
      const response = await api.post(
        endpoint,
        body
      );

      return response?.data;
    },
    [api]
  );

  const createAudienceGroup = useCallback(
    async (payload) => {
      try {
        if (!userID) return null;

        setLoading(true);

        const data = await postRequest(
          "/LeadManagement/createAudienceGroup",
          {
            userid: userID,
            audienceGroupName:
              payload.audienceGroupName,
            members: payload.members,
          }
        );

        if (data?.responseCode === "00") {
          sessionStorage.removeItem(
            `audience_groups_${userID}`
          );

          setAudienceFetched(false);
        }

        return data;
      } catch (error) {
        console.error(
          "Create audience group error:",
          error?.response?.data || error
        );

        return null;
      } finally {
        setLoading(false);
      }
    },
    [
      postRequest,
      userID,
      setAudienceFetched,
    ]
  );

  return {
    audienceGroups,
    createAudienceGroup,
    loading,
    setAudienceGroups,
  };
};

export default useAudience;